
  (function () {
    var form = document.getElementById('kontakt-form');
    var ok = document.getElementById('kf-success');
    if (!form || !ok) return;
    var btn = form.querySelector('button[type="submit"]');
    function zeigeBestaetigung() {
      form.reset();
      ok.hidden = false;
      ok.classList.remove('is-visible'); void ok.offsetWidth; ok.classList.add('is-visible');
      var r = ok.getBoundingClientRect();
      var ziel = r.top + (window.pageYOffset || 0) - Math.max((window.innerHeight - r.height) / 2, 24);
      try { window.scrollTo({ top: Math.max(ziel, 0), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(ziel, 0)); }
    }
    var okText = ok.querySelector('span');
    var okStandard = okText ? okText.innerHTML : '';
    form.addEventListener('input', function () { ok.hidden = true; if (okText) okText.innerHTML = okStandard; });

    // Catering-Anfrage (Formular über einen Catering-Knopf geöffnet, nados-7.js): an die CateringAPP senden.
    // Die App legt die Anfrage an und schickt der Kundin die Mail mit dem Link zur Auswahl.
    function fehlerZeigen(liste) {
      var box = form.querySelector('.nd-form-fehler');
      if (!box) { box = document.createElement('div'); box.className = 'nd-form-fehler'; form.insertBefore(box, form.firstChild); }
      box.textContent = liste.join(' ');
      box.hidden = false;
    }
    function anCateringApp() {
      var fd = new FormData(form);
      var r0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var daten = { name: fd.get('contact[name]') || '', email: fd.get('contact[email]') || '', subject: fd.get('contact[Betreff]') || '', message: fd.get('contact[body]') || '' };
      return fetch(r0 + 'apps/catering/anfrage', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(daten) })
        .then(function (r) { return r.json(); });
    }
    function istCatering() { return form.getAttribute('data-catering') === '1'; }
    function sendeCatering() {
      if (btn) btn.disabled = true;
      var alteFehler = form.querySelector('.nd-form-fehler'); if (alteFehler) alteFehler.hidden = true;
      anCateringApp().then(function (d) {
        if (btn) btn.disabled = false;
        if (!d || !d.ok) { fehlerZeigen((d && d.errors) || ['Das hat leider nicht geklappt. Bitte versuch es noch einmal.']); return; }
        if (okText && d.message) okText.textContent = d.message;
        zeigeBestaetigung();
      }).catch(function () {
        // App nicht erreichbar: als normale Kontaktnachricht senden, damit die Anfrage nicht verloren geht
        if (btn) btn.disabled = false;
        form.removeAttribute('data-catering');
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
    // Catering: schon den Klick auf „Senden“ abfangen (Enter im Formular löst denselben Klick aus). Sonst schickt
    // Shopifys eigener Spam-Schutz für Kontaktformulare das Formular zusätzlich ab und zeigt eine Sicherheitsabfrage.
    window.addEventListener('click', function (e) {
      if (!btn || !istCatering() || !(e.target === btn || btn.contains(e.target))) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (form.reportValidity()) sendeCatering();
    }, true);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      if (istCatering()) { e.stopImmediatePropagation(); sendeCatering(); return; }
      // Im Shopify-Shop an den Shopify-Kontaktendpunkt senden (Vorschau: nur Bestaetigung)
      if (!form.getAttribute('action') && window.Shopify) {
        var r0 = (Shopify.routes && Shopify.routes.root) || '/';
        form.setAttribute('action', r0 + 'contact#kontakt-form');
        form.setAttribute('method', 'post');
      }
      var action = form.getAttribute('action');
      if (!action) { zeigeBestaetigung(); return; }
      if (btn) btn.disabled = true;
      fetch(action, { method: 'POST', body: new URLSearchParams(new FormData(form)), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          if (r.ok && /[?&]contact_posted=true/.test(r.url)) { if (btn) btn.disabled = false; zeigeBestaetigung(); }
          else { form.submit(); }
        })
        .catch(function () { form.submit(); });
    });
  })();
  
;

  (function () {
    var links = document.querySelectorAll('[data-legal-scroll]');
    Array.prototype.forEach.call(links, function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(a.getAttribute('data-legal-scroll'));
        if (!t) return;
        var top = t.getBoundingClientRect().top + (window.pageYOffset || 0) - 110;
        try { window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' }); } catch (err) { window.scrollTo(0, Math.max(top, 0)); }
      });
    });
  })();
  
;

  (function() {
    var mb = document.getElementById('menu-btn');
    var nav = document.querySelector('.nav-links');
    if (!mb || !nav) return;
    function closeMenu() {
      nav.classList.remove('open');
      mb.classList.remove('open');
      document.body.classList.remove('menu-open');
      mb.setAttribute('aria-expanded', 'false');
    }
    var actions = document.querySelector('.header-actions');
    var headerRow = actions ? actions.parentElement : null;
    var pageRoot = document.querySelector('body > div') || document.body;
    function placeActions() {
      if (!actions || !headerRow) return;
      var mobile = window.matchMedia('(max-width: 1000px)').matches;
      if (mobile && actions.parentElement !== pageRoot) pageRoot.appendChild(actions);
      else if (!mobile && actions.parentElement !== headerRow) headerRow.appendChild(actions);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeActions);
    } else {
      placeActions();
    }
    window.addEventListener('resize', placeActions);

    mb.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = nav.classList.toggle('open');
      mb.classList.toggle('open', isOpen);
      document.body.classList.toggle('menu-open', isOpen);
      mb.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    nav.addEventListener('click', function(e) { if (e.target.tagName === 'A') closeMenu(); });
    document.addEventListener('click', function(e) {
      if (nav.classList.contains('open') && !nav.contains(e.target) && !mb.contains(e.target)) closeMenu();
    });
  })();
